import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import { Asset } from '@mux/mux-node';

interface metadataState {
  value: Metadata | null;
  isLoading: boolean;
  error: string;
}

const initialState: metadataState = {
  value: null,
  isLoading: false,
  error: '',
};

export const metadataSlice = createSlice({
  name: 'metadata',
  initialState,
  reducers: {
    setMetadata(state, action: PayloadAction<Metadata>) {
      const metadata = action.payload;
      state.value = metadata;
    },

    //

    getMetadataRequested(state) {
      state.isLoading = true;
    },
    getMetadataSucceeded(state, action: PayloadAction<Metadata>) {
      const metadata = action.payload;
      state.value = metadata;
    },
    getMetadataFailed(state, action: PayloadAction<SagaError>) {
      const { message } = action.payload;
      state.error = message;
    },

    createMetadataRequested(state, action: PayloadAction<Media>) {
      state.isLoading = true;
    },
    createMetadataSucceeded(state, action: PayloadAction<Metadata>) {
      const metadata = action.payload;
      state.value = metadata;
    },
    createMetadataFailed(state, action: PayloadAction<SagaError>) {
      const { message } = action.payload;
      state.error = message;
    },
  },
});

export default metadataSlice.reducer;
export const {
  getMetadataRequested,
  getMetadataSucceeded,
  getMetadataFailed,
  createMetadataRequested,
  createMetadataSucceeded,
  createMetadataFailed,
} = metadataSlice.actions;
